module.exports = __webpack_public_path__ + "static/media/Screenshot1.61158753.png";